<template>
  <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <div class="profile-content">
        <h1>Membership Reports</h1>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                <v-spacer/>
                <v-spacer/>
                <v-spacer/>
                <v-spacer/>
                <v-select
                    label="Class"
                    :items="mailATClassFilters"
                    item-text="label"
                    item-value="value"
                    v-model="selectedATClasses"
                    multiple
                  ></v-select>
                  <v-spacer/>
                  <v-btn 
                    large
                    color="primary"
                    @click="csvExport"
                    >CSV Export</v-btn>
              </v-card-title>
              <v-card-text>
                <report-viewer    
                  reportName="Asca.Api.Reports.rpt1252_Person_Membership_Aussie_Report.rdlx"
                  :dataUrl="`/reports/membership/aussieTimes?classes=${selectedATClasses.join('|')}`"
                  ref="reportViewer"
                  :printOnly="true"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>    
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import ReportViewer from '@/components/Admin/Reports/ReportViewer.vue';
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "MembershipReport",
  components: {
    ReportViewer
  },
  data: function() {
    return {
      showLoader: false,
      errorMessage: "",
      mailATClassFilters: [
        {value: 'true', label: '1st'},
        {value: 'false', label: '2nd'},
      ],
      selectedATClasses: [
        'true', 'false'
      ]
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    reportViewer(): any {
      return this.$refs.reportViewer;
    }
  },
  methods: {
    async csvExport() {      
      this.reportViewer.exportToCsv('csv', null, false, {PrintOnOpen: 'true'})
    },
  },
});
</script>
